var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vs-popup",
    {
      staticClass: "sales-closures-details-modal",
      attrs: {
        title: "Detalle del cierre de ventas",
        active: _vm.isOpen,
        fullscreen: "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isOpen = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        { staticClass: "sales-closures-details-container p-6 space-y-6" },
        [
          _vm.closure
            ? _c("div", { staticClass: "space-y-6" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "bg-gradient-to-r from-latinad to-latinad-light p-6 rounded-lg text-white",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex justify-between items-center mb-4" },
                      [
                        _c("h2", { staticClass: "text-2xl font-bold" }, [
                          _vm._v(
                            "Cierre #" +
                              _vm._s(_vm.getClosureDisplayNumber(_vm.closure))
                          ),
                        ]),
                        _c(
                          "vs-chip",
                          {
                            staticClass: "text-white text-sm",
                            attrs: {
                              color:
                                _vm.CLOSURE_STATUS_COLORS[_vm.closure.status],
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.CLOSURE_STATUS_LABELS[_vm.closure.status]
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "grid grid-cols-4 gap-4 text-sm" },
                      [
                        _c("div", [
                          _c("p", { staticClass: "opacity-75 mb-1" }, [
                            _vm._v("Período"),
                          ]),
                          _c("p", { staticClass: "font-semibold" }, [
                            _vm._v(
                              _vm._s(_vm.dateFormatter(_vm.closure.date_from)) +
                                " a " +
                                _vm._s(_vm.dateFormatter(_vm.closure.date_to))
                            ),
                          ]),
                        ]),
                        _c("div", [
                          _c("p", { staticClass: "opacity-75 mb-1" }, [
                            _vm._v("Monto Total"),
                          ]),
                          _c("p", { staticClass: "font-semibold" }, [
                            _vm._v(
                              _vm._s(
                                _vm.stringCurrencyFormatter(_vm.closure.amount)
                              ) +
                                " " +
                                _vm._s(_vm.closure.currency)
                            ),
                          ]),
                        ]),
                        _c("div", [
                          _c("p", { staticClass: "opacity-75 mb-1" }, [
                            _vm._v("Creado"),
                          ]),
                          _c("p", { staticClass: "font-semibold" }, [
                            _vm._v(
                              _vm._s(_vm.dateFormatter(_vm.closure.created_at))
                            ),
                          ]),
                          _vm.closure.canceled_at
                            ? _c("p", { staticClass: "font-semibold" }, [
                                _vm._v(
                                  "Anulado: " +
                                    _vm._s(
                                      _vm.dateFormatter(_vm.closure.canceled_at)
                                    )
                                ),
                              ])
                            : _vm.closure.updated_at
                            ? _c("p", { staticClass: "font-semibold" }, [
                                _vm._v(
                                  "Actualizado: " +
                                    _vm._s(
                                      _vm.dateFormatter(_vm.closure.updated_at)
                                    )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _c("div", [
                          _c("p", { staticClass: "opacity-75 mb-1" }, [
                            _vm._v("Modo Comisión"),
                          ]),
                          _c("p", { staticClass: "font-semibold" }, [
                            _vm._v(
                              _vm._s(
                                _vm.AGENCY_COMMISSION_MODES_LABELS[
                                  _vm.closure.agency_commission_mode
                                ]
                              )
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
                _c("div", { staticClass: "border-t pt-6" }, [
                  _c(
                    "h3",
                    { staticClass: "font-semibold mb-4 text-sm uppercase" },
                    [_vm._v("Información de la Empresa")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "grid grid-cols-2 gap-4 p-4 bg-gray-50 rounded border border-gray-200",
                    },
                    [
                      _c("div", [
                        _c("p", { staticClass: "text-sm text-gray-600 mb-1" }, [
                          _vm._v("Nombre Fantasía"),
                        ]),
                        _c("p", { staticClass: "font-semibold" }, [
                          _vm._v(
                            _vm._s(_vm.getClosureFantasyName(_vm.closure))
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("p", { staticClass: "text-sm text-gray-600 mb-1" }, [
                          _vm._v("Razón Social"),
                        ]),
                        _c("p", { staticClass: "font-semibold" }, [
                          _vm._v(_vm._s(_vm.getClosureLegalName(_vm.closure))),
                        ]),
                      ]),
                      _vm.closure.responsible_agency
                        ? _c("div", [
                            _c(
                              "p",
                              { staticClass: "text-sm text-gray-600 mb-1" },
                              [_vm._v("Agencia Responsable")]
                            ),
                            _c("p", { staticClass: "font-semibold" }, [
                              _vm._v(
                                _vm._s(_vm.closure.responsible_agency.name)
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "border-t pt-6" }, [
                  _c(
                    "h3",
                    { staticClass: "font-semibold mb-4 text-sm uppercase" },
                    [_vm._v("Autor del Cierre")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "p-4 bg-blue-50 rounded border border-blue-200",
                    },
                    [
                      _vm.closure.author
                        ? _c("div", { staticClass: "space-y-2" }, [
                            _c(
                              "p",
                              { staticClass: "font-semibold text-gray-800" },
                              [
                                _vm._v(
                                  _vm._s(_vm.closure.author.first_name) +
                                    " " +
                                    _vm._s(_vm.closure.author.last_name)
                                ),
                              ]
                            ),
                            _c("p", { staticClass: "text-sm text-gray-600" }, [
                              _vm._v(_vm._s(_vm.closure.author.email)),
                            ]),
                            _vm.closure.status === "valid"
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-xs text-green-700 bg-green-100 px-2 py-1 rounded w-fit",
                                  },
                                  [
                                    _vm._v(
                                      "\n              ✓ Autor congelado (cierre validado)\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _c("div", { staticClass: "text-gray-500 italic" }, [
                            _c("p", [_vm._v("Sin información de autor")]),
                          ]),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "border-t pt-6" }, [
                  _c(
                    "h3",
                    { staticClass: "font-semibold mb-4 text-sm uppercase" },
                    [_vm._v("Facturación y Pago")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "grid grid-cols-4 gap-4 p-4 bg-gray-50 rounded border border-gray-200",
                    },
                    [
                      _c("div", [
                        _c("p", { staticClass: "text-sm text-gray-600 mb-1" }, [
                          _vm._v("Modo Facturación"),
                        ]),
                        _c("p", { staticClass: "font-semibold" }, [
                          _vm._v(
                            _vm._s(
                              _vm.BILLING_MODES_LABELS[_vm.closure.billing_mode]
                            )
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("p", { staticClass: "text-sm text-gray-600 mb-1" }, [
                          _vm._v("Modo Pago"),
                        ]),
                        _c("p", { staticClass: "font-semibold" }, [
                          _vm._v(
                            _vm._s(
                              _vm.PAYMENT_MODES_LABELS[_vm.closure.payment_mode]
                            )
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("p", { staticClass: "text-sm text-gray-600 mb-1" }, [
                          _vm._v("Plazo Pago (días)"),
                        ]),
                        _c("p", { staticClass: "font-semibold" }, [
                          _vm._v(_vm._s(_vm.closure.payment_term)),
                        ]),
                      ]),
                      _c("div", [
                        _c("p", { staticClass: "text-sm text-gray-600 mb-1" }, [
                          _vm._v("Plazo Cobro (días)"),
                        ]),
                        _c("p", { staticClass: "font-semibold" }, [
                          _vm._v(_vm._s(_vm.closure.charge_term)),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "border-t pt-6" }, [
                  _c(
                    "h3",
                    { staticClass: "font-semibold mb-4 text-sm uppercase" },
                    [_vm._v("Comisiones e Impuestos")]
                  ),
                  _c("div", { staticClass: "space-y-3" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-amber-50 p-4 rounded border border-amber-200",
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "font-bold text-amber-900 mb-3 text-sm",
                          },
                          [_vm._v("Comisión Agencia")]
                        ),
                        _c(
                          "div",
                          { staticClass: "grid grid-cols-3 gap-4 text-sm" },
                          [
                            _c("div", [
                              _c("p", { staticClass: "text-gray-600 mb-1" }, [
                                _vm._v("Porcentaje"),
                              ]),
                              _c("p", { staticClass: "font-semibold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.closure.agency_commission_percentage
                                  ) + "%"
                                ),
                              ]),
                            ]),
                            _c("div", [
                              _c("p", { staticClass: "text-gray-600 mb-1" }, [
                                _vm._v("Monto"),
                              ]),
                              _c(
                                "p",
                                { staticClass: "font-bold text-amber-900" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.stringCurrencyFormatter(
                                        _vm.closure.agency_commission_amount
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", [
                              _c("p", { staticClass: "text-gray-600 mb-1" }, [
                                _vm._v("Moneda"),
                              ]),
                              _c("p", { staticClass: "font-semibold" }, [
                                _vm._v(
                                  _vm._s(_vm.closure.agency_commission_currency)
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-blue-50 p-4 rounded border border-blue-200",
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "font-bold text-blue-900 mb-3 text-sm",
                          },
                          [_vm._v("Comisión Exchange")]
                        ),
                        _c(
                          "div",
                          { staticClass: "grid grid-cols-3 gap-4 text-sm" },
                          [
                            _c("div", [
                              _c("p", { staticClass: "text-gray-600 mb-1" }, [
                                _vm._v("Porcentaje"),
                              ]),
                              _c("p", { staticClass: "font-semibold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.closure.exchange_commission_percentage
                                  ) + "%"
                                ),
                              ]),
                            ]),
                            _c("div", [
                              _c("p", { staticClass: "text-gray-600 mb-1" }, [
                                _vm._v("Monto"),
                              ]),
                              _c(
                                "p",
                                { staticClass: "font-bold text-blue-900" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.stringCurrencyFormatter(
                                        _vm.closure.exchange_commission_amount
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", [
                              _c("p", { staticClass: "text-gray-600 mb-1" }, [
                                _vm._v("Moneda"),
                              ]),
                              _c("p", { staticClass: "font-semibold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.closure.exchange_commission_currency
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-red-50 p-4 rounded border border-red-200",
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "font-bold text-red-900 mb-3 text-sm",
                          },
                          [_vm._v("Impuesto Internacional")]
                        ),
                        _c(
                          "div",
                          { staticClass: "grid grid-cols-3 gap-4 text-sm" },
                          [
                            _c("div", [
                              _c("p", { staticClass: "text-gray-600 mb-1" }, [
                                _vm._v("Porcentaje"),
                              ]),
                              _c("p", { staticClass: "font-semibold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.closure.international_tax_percentage
                                  ) + "%"
                                ),
                              ]),
                            ]),
                            _c("div", [
                              _c("p", { staticClass: "text-gray-600 mb-1" }, [
                                _vm._v("Monto"),
                              ]),
                              _c(
                                "p",
                                { staticClass: "font-bold text-red-900" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.stringCurrencyFormatter(
                                        _vm.closure.international_tax_amount
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", [
                              _c("p", { staticClass: "text-gray-600 mb-1" }, [
                                _vm._v("Moneda"),
                              ]),
                              _c("p", { staticClass: "font-semibold" }, [
                                _vm._v(
                                  _vm._s(_vm.closure.international_tax_currency)
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-emerald-50 p-4 rounded border border-emerald-200",
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "font-bold text-emerald-900 mb-3 text-sm",
                          },
                          [_vm._v("Impuestos Nacionales")]
                        ),
                        _c(
                          "div",
                          { staticClass: "grid grid-cols-3 gap-4 text-sm" },
                          [
                            _c("div", [
                              _c("p", { staticClass: "text-gray-600 mb-1" }, [
                                _vm._v("Porcentaje"),
                              ]),
                              _c("p", { staticClass: "font-semibold" }, [
                                _vm._v(
                                  _vm._s(_vm.closure.national_tax_percentage) +
                                    "%"
                                ),
                              ]),
                            ]),
                            _c("div", [
                              _c("p", { staticClass: "text-gray-600 mb-1" }, [
                                _vm._v("Monto"),
                              ]),
                              _c(
                                "p",
                                { staticClass: "font-bold text-emerald-900" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.stringCurrencyFormatter(
                                        _vm.closure.national_tax_amount
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", [
                              _c("p", { staticClass: "text-gray-600 mb-1" }, [
                                _vm._v("Moneda"),
                              ]),
                              _c("p", { staticClass: "font-semibold" }, [
                                _vm._v(
                                  _vm._s(_vm.closure.national_tax_currency)
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "border-t pt-6" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "p-6 bg-gray-50 rounded border border-gray-200",
                    },
                    [
                      _c("p", { staticClass: "text-sm text-gray-600 mb-2" }, [
                        _vm._v("Base de Cálculo"),
                      ]),
                      _c(
                        "p",
                        { staticClass: "font-bold text-latinad text-lg" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.stringCurrencyFormatter(
                                _vm.closure.calculation_base
                              )
                            ) +
                              " " +
                              _vm._s(_vm.closure.currency)
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }